import Head from 'next/head';
import React from 'react';

import {
  AHREFS_SITE_VERIFICATION,
  POCKET_SITE_VERIFICATION,
  MSAPPPLICATION_TILE_COLOR,
  FACEBOOK_PAGES_CHANNEL_1,
  FACEBOOK_PAGES_CHANNEL_2
} from 'constants/vendor';
import { colorPalette } from 'styles/css-constants';

function DefaultMetadata() {
  return (
    <Head>
      <meta charSet="utf-8" />
      <meta name="theme-color" content="#ffffff" />
      <meta property="fb:admins" content="1917611" />
      <meta property="fb:pages" content={FACEBOOK_PAGES_CHANNEL_1} />
      <meta property="fb:pages" content={FACEBOOK_PAGES_CHANNEL_2} />
      <meta
        name="pocket-site-verification"
        content={POCKET_SITE_VERIFICATION}
      />
      <meta
        name="ahrefs-site-verification"
        content={AHREFS_SITE_VERIFICATION}
      />
      <meta
        name="msapplication-TileColor"
        content={MSAPPPLICATION_TILE_COLOR}
      />
      <meta
        name="msapplication-TileImage"
        content="/static/icons/metro-tile.png"
      />
      <link
        href="https://plus.google.com/106296982733310215038/"
        rel="publisher"
      />
      <link rel="apple-touch-icon" href="/static/icons/apple-touch-icon.png" />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/static/icons/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/static/icons/favicon-16x16.png"
      />
      <link
        rel="mask-icon"
        href="/static/icons/safari-pin-icon.svg"
        color={colorPalette.brand}
      />
      <link rel="shortcut icon" href="/static/favicons/favicon.ico" />
      <link rel="manifest" href="/manifest.webmanifest" />
    </Head>
  );
}

export default DefaultMetadata;
